module.exports = __webpack_public_path__ + "static/media/Neoturis.78702bd7.ico";